<script setup lang="ts">
import {
  Contexts,
  NamedBindings,
  TranslationService,
  getContainer,
} from '@dandelion/core';
import { DaysText } from '../enum/DaysText';
import { ref } from 'vue';

defineProps<{
  cbArray: Array<any>;
}>();

const ts = getContainer(Contexts.DEFAULT).get(
  NamedBindings.TranslationService
) as TranslationService;

const emit = defineEmits<{
  (e: 'setColor', color: DaysText): void;
}>();

const currentColor = ref(DaysText.GREY);
const currentLabel = ref(DaysText.DAY_NOT_COMPILED);

const setColor = (color: DaysText, label: DaysText) => {
  currentLabel.value = label;
  currentColor.value = color;
  emit('setColor', color);
};
</script>

<template>
  <h3 v-html="ts.t(DaysText.AVAILABLE_PERIODS)"></h3>
  <div class="colorSelector">
    <button
      v-for="cb in cbArray"
      type="button"
      :class="{
        nonCompiled: cb.color == DaysText.GREY,
        oneVasoactive: cb.color == DaysText.YELLOW,
        twoOrMoreVasoactive: cb.color == DaysText.RED,
        withoutAssistence: cb.color == DaysText.BLUE,
        withAssistence: cb.color == DaysText.PURPLE,
      }"
      @click="setColor(cb.color, cb.label)"
      v-html="ts.t(cb.label)"
    ></button>
    <div class="selectedColorContainer">
      <h4 v-html="ts.t(DaysText.YOU_SELECT) + ts.t(currentLabel)"></h4>
      <div
        :class="{
          selectedColor: true,
          nonCompiled: currentColor == DaysText.GREY,
          oneVasoactive: currentColor == DaysText.YELLOW,
          twoOrMoreVasoactive: currentColor == DaysText.RED,
          withoutAssistence: currentColor == DaysText.BLUE,
          withAssistence: currentColor == DaysText.PURPLE,
        }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
#start\.administeredAmine\.aminePlugin > h3,
#start\.minorRespiratory\.minorRespiratoryPlugin > h3 {
  font-size: 1.25rem;
  margin: 1rem 0;
}

.colorSelector {
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
}

.colorSelector button {
  margin: 0 0.25rem;
  line-height: normal;
}

.colorSelector button {
  box-shadow: none;
  color: #000;
}

.colorSelector .nonCompiled {
  background-color: #ebf0f3;
}

.colorSelector .oneVasoactive {
  background-color: rgba(255, 255, 0, 0.5);
}

.colorSelector .twoOrMoreVasoactive {
  background-color: rgba(255, 0, 0, 0.5);
}

.colorSelector .withoutAssistence {
  background-color: rgba(0, 0, 255, 0.5);
}

.colorSelector .withAssistence {
  background-color: rgba(225, 0, 255, 0.5);
}

.selectedColorContainer {
  display: flex;
  align-items: center;
  padding: 0;
}

.selectedColorContainer h4 {
  margin: 0 1rem;
  white-space: nowrap;
}

.selectedColorContainer .selectedColor {
  width: 3rem;
  aspect-ratio: 1;
  box-shadow: none;
  border-radius: 0.25rem;
  cursor: pointer;
}
</style>
